import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  InputGroup,
  Table,
  Card,
  ListGroup,
  Modal
} from 'react-bootstrap';
import PageTitle from '../../common/PageTitle';
import TypeBadge from '../../common/TypeBadge';
import FormattedPrice from '../../common/FormattedPrice';
import FormattedTax from '../../common/FormattedTax';
import braUfCities from '../../../assets/json/braUfCities.json';
import { apiListBases, apiListReleases, apiListCostGroups, apiListResults, apiListServiceItems, apiListTaxes } from '../../../api/api';
import { useUser } from '../../../context/UserContext';
import { useToast } from '../../../context/ToastContext';
import { useCart } from '../../../context/CartContext';
import './Search.css';

const ElementsPopup = ({ show, handleClose, element, handlePrev, handleNext, selectedBaseName, selectedReleaseName, selectedPraca, taxes }) => (
  <Modal
    show={show}
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
    fullscreen={true}>
    <Modal.Header className="bg-info text-dark">
      <Modal.Title>Detalhes do Insumo</Modal.Title>
    </Modal.Header>
    <Modal.Body >
      <div className=''>
        <div>
          <table className='table table-sm table-bordered table-striped-columns'>
            <tbody>
              <tr>
                <td className='fw-semibold w-25'>Base</td>
                <td>{selectedBaseName}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Versão</td>
                <td>{selectedReleaseName}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Praça</td>
                <td>{selectedPraca}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Grupo de Custos</td>
                <td>{element.CostGroup && element.CostGroup.description ? element.CostGroup.description : ''}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Código do insumo</td>
                <td>{element.code}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Descrição do insumo</td>
                <td>{element.description}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Unidade</td>
                <td>{element.unity}</td>
              </tr>
              <tr>
                <td className='fw-semibold'>Preço CLSD<br /><i>Com leis sociais desonerado</i></td>
                <td><FormattedPrice type='clsd' price={element.ElementPrices && element.ElementPrices.length > 0 ? element.ElementPrices[0].clsd : 0} /></td>
              </tr>
              <tr>
                <td className='fw-semibold'>Preço CLSN<br /><i>Com leis sociais não-desonerado</i></td>
                <td><FormattedPrice type='clsn' price={element.ElementPrices && element.ElementPrices.length > 0 ? element.ElementPrices[0].clsn : 0} /></td>
              </tr>
              <tr>
                <td className='fw-semibold'>Preço SLS<br /><i>Sem leis sociais</i></td>
                <td><FormattedPrice type='sls' price={element.ElementPrices && element.ElementPrices.length > 0 ? element.ElementPrices[0].sls : 0} /></td>
              </tr>
            </tbody>
          </table>
        </div>
        {taxes && (
          <div>
            <table className='table table-sm table-bordered table-striped-columns'>
              <thead>
                <tr>
                  <th colSpan={2}>Taxas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='fw-semibold w-25'>Horista Desonerado</td>
                  <td><FormattedTax tax={taxes.hourly_exonerated} /></td>
                </tr>
                <tr>
                  <td className='fw-semibold'>Horista Não Desonerado</td>
                  <td><FormattedTax tax={taxes.hourly_not_exonerated} /></td>
                </tr>
                <tr>
                  <td className='fw-semibold'>Mensalista Desonerado</td>
                  <td><FormattedTax tax={taxes.monthly_exonerated} /></td>
                </tr>
                <tr>
                  <td className='fw-semibold'>Mensalista Não Desonerado</td>
                  <td><FormattedTax tax={taxes.monthly_not_exonerated} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handlePrev}>
        <i className="bi bi-arrow-left-square"> ANTERIOR</i>
      </Button>
      <Button variant="primary" onClick={handleNext}>
        <i className="bi bi-arrow-right-square"> PRÓXIMO</i>
      </Button>
      <Button variant="secondary" onClick={handleClose}>
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);

const ServicesPopup = ({ show, handleClose, service, handlePrev, handleNext, selectedBaseName, selectedReleaseName, selectedPraca, items }) => (
  <Modal
    show={show}
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
    fullscreen={true}>
    <Modal.Header className="bg-warning text-dark">
      <Modal.Title>Detalhes do Serviço</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <table className='table table-sm table-bordered table-striped-columns'>
          <tbody>
            <tr>
              <td className='fw-semibold'>Base</td>
              <td>{selectedBaseName}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Versão</td>
              <td>{selectedReleaseName}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Praça</td>
              <td>{selectedPraca}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Grupo de Custos</td>
              <td>{service.CostGroup && service.CostGroup.description ? service.CostGroup.description : ''}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Código do serviço</td>
              <td>{service.code}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Descrição do serviço</td>
              <td>{service.description}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Unidade</td>
              <td>{service.unity}</td>
            </tr>
            <tr>
              <td className='fw-semibold'>Preço CLSD<br /><i>Com leis sociais desonerado</i></td>
              <td><FormattedPrice type='clsd' price={service.ElementPrices && service.ElementPrices.length > 0 ? service.ElementPrices[0].clsd : 0} /></td>
            </tr>
            <tr>
              <td className='fw-semibold'>Preço CLSN<br /><i>Com leis sociais não-desonerado</i></td>
              <td><FormattedPrice type='clsn' price={service.ElementPrices && service.ElementPrices.length > 0 ? service.ElementPrices[0].clsn : 0} /></td>
            </tr>
            <tr>
              <td className='fw-semibold'>Preço SLS<br /><i>Sem leis sociais</i></td>
              <td><FormattedPrice type='sls' price={service.ElementPrices && service.ElementPrices.length > 0 ? service.ElementPrices[0].sls : 0} /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table id="detailsTable" className="table table-sm table-hover">
          <thead>
            <tr>
              <th colSpan={5}>&nbsp;</th>
              <th colSpan={3}>Preços</th>
            </tr>
            <tr>
              <th>Tipo</th>
              <th>Código</th>
              <th>Grupo de Custos<br />Descrição</th>
              <th>Un.</th>
              <th>Coeficiente</th>
              <th>CLSD</th>
              <th>CLSN</th>
              <th>SLS</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td valign='middle'><TypeBadge type={item.ResElement.type} /></td>
                <td valign='middle'>{item.ResElement.code}</td>
                <td valign='middle'><span className='text-secondary'>{item.ResElement.CostGroup.description}</span><br />{item.ResElement.description}</td>
                <td valign='middle'>{item.ResElement.unity}</td>
                <td valign='middle'>{item.coefficient}</td>
                <td valign='middle'><FormattedPrice type='clsd' price={item.ResElement.ElementPrices.length > 0 ? item.ResElement.ElementPrices[0].clsd : 0} /></td>
                <td valign='middle'><FormattedPrice type='clsn' price={item.ResElement.ElementPrices.length > 0 ? item.ResElement.ElementPrices[0].clsn : 0} /></td>
                <td valign='middle'><FormattedPrice type='sls' price={item.ResElement.ElementPrices.length > 0 ? item.ResElement.ElementPrices[0].sls : 0} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handlePrev}>
        <i className="bi bi-arrow-left-square"> ANTERIOR</i>
      </Button>
      <Button variant="primary" onClick={handleNext}>
        <i className="bi bi-arrow-right-square"> PRÓXIMO</i>
      </Button>
      <Button variant="secondary" onClick={handleClose}>
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);

const Search = () => {
  const { user, updateUser } = useUser();
  const { cart, updateCart } = useCart();
  const { addToast } = useToast();

  const [selectedPraca, setSelectedPraca] = useState('');
  const [selectedBase, setSelectedBase] = useState('');
  const [selectedBaseName, setSelectedBaseName] = useState('');
  const [selectedRelease, setSelectedRelease] = useState('');
  const [selectedReleaseName, setSelectedReleaseName] = useState('');

  const [bases, setBases] = useState([]);
  const [releases, setReleases] = useState([]);
  const [costGroups, setCostGroups] = useState([]);
  const [results, setResults] = useState([]);
  const [taxes, setTaxes] = useState(null);

  const [has, setHas] = useState([]);
  const [hasText, setHasText] = useState('');
  const [newWithItem, setNewWithItem] = useState('');
  const [hasNot, setHasNot] = useState([]);
  const [hasNotText, setHasNotText] = useState('');
  const [newWithoutItem, setNewWithoutItem] = useState('');

  const [loadingCostGroups, setLoadingCostGroups] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);

  const [activeCostGroup, setActiveCostGroup] = useState('');

  const [showElements, setShowElements] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [serviceItems, setServiceItems] = useState([]);

  const [costGroupFilter, setCostGroupFilter] = useState('');
  const [filteredCostGroups, setFilteredCostGroups] = useState([]);

  const handleWithAddItem = () => {
    if (newWithItem.trim() !== '') {
      setHas([...has, newWithItem]);
      setNewWithItem('');
    }
  };
  const handleHasRemoveItem = (index) => {
    setHas(has.filter((_, i) => i !== index));
  };
  const handleWithKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleWithAddItem();
    }
  };
  useEffect(() => {
    const fetchHas = async () => {
      if (has && has.length > 0) {
        setHasText(has.join('|'));
      } else {
        setHasText('');
      }
    };
    fetchHas();
  }, [has]);

  useEffect(() => {
    const fetchData = async () => {
      setCostGroups([]);
      setResults([]);
      await loadCostGroups();
    };
    fetchData();
  }, [hasText]);


  const handleWithoutAddItem = () => {
    if (newWithoutItem.trim() !== '') {
      setHasNot([...hasNot, newWithoutItem]);
      setNewWithoutItem('');
    }
  };
  const handleHasNotRemoveItem = (index) => {
    setHasNot(hasNot.filter((_, i) => i !== index));
  };
  const handleWithoutKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleWithoutAddItem();
    }
  };
  useEffect(() => {
    const fetchHasNot = async () => {
      if (hasNot && hasNot.length > 0) {
        setHasNotText(hasNot.join('|'));
      } else {
        setHasNotText('');
      }
    };
    fetchHasNot();
  }, [hasNot]);

  useEffect(() => {
    const fetchData = async () => {
      setCostGroups([]);
      setResults([]);
      await loadCostGroups();
    };
    fetchData();
  }, [hasNotText]);


  // BASES
  useEffect(() => {
    const fetchBases = async () => {
      try {

        const response = await apiListBases(selectedPraca);
        if (response && Array.isArray(response)) {
          setBases(response);
        }
      } catch (error) {
        addToast('Erro ao buscar bases');
      }
    };
    setBases([]);
    setSelectedBase('');
    setReleases([]);
    setSelectedRelease('');
    setCostGroups([]);
    setResults([]);

    if (selectedPraca && selectedPraca !== '') {
      fetchBases();
    }
  }, [selectedPraca]);

  // RELEASES
  useEffect(() => {
    const fetchReleases = async () => {
      try {
        const response = await apiListReleases(selectedBase);
        if (response && Array.isArray(response)) {
          setReleases(response);
        }
      } catch (error) {
        addToast('Erro ao buscar bases');
      }
    };
    setReleases([]);
    setSelectedRelease('');
    setCostGroups([]);
    setResults([]);
    if (selectedBase && selectedBase !== '') {
      setSelectedBaseName(bases.find(base => base.id.toString() === selectedBase.toString()).name);
      fetchReleases();
    }
  }, [selectedBase]);


  // COST GROUPS
  useEffect(() => {
    const fetchCostGroups = async () => {
      await loadCostGroups();
    };
    setCostGroups([]);
    setResults([]);
    if (selectedRelease && selectedRelease !== '') {
      fetchCostGroups();
    }
  }, [selectedRelease]);


  useEffect(() => {
    setFilteredCostGroups(costGroups.filter(costGroup => costGroup.description.toLowerCase().includes(costGroupFilter.toLowerCase())));
  }, [costGroupFilter, costGroups]);

  const loadCostGroups = async () => {
    setActiveCostGroup('');

    if (!selectedRelease || selectedRelease === '') {
      return;
    }
    setLoadingCostGroups(true);
    try {
      const response = await apiListCostGroups(selectedRelease, hasText, hasNotText);
      setCostGroups(response);
      const rel = releases.find(release => release.id.toString() === selectedRelease.toString());
      if (rel) {
        setSelectedReleaseName(rel.year + '/' + rel.month.toString().padStart(2, '0'));
      }
    } catch (error) {
      addToast('Erro ao buscar bases');
    } finally {
      setLoadingCostGroups(false);
    }
  };


  const handleCostGroupClick = async (costGroupId) => {
    if (user.searches >= 5 && user.subscription === 0) {
      addToast('Limite de pesquisas atingido. Contrate um plano para continuar utilizando o sistema.');
      return;
    }

    setActiveCostGroup(costGroupId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoadingResults(true);
    setResults([]);
    setTaxes(null);
    try {
      const response = await apiListResults(selectedPraca, costGroupId, hasText, hasNotText, user.id);
      const updatedUser = { ...user, searches: (user.searches || 0) + 1 };
      updateUser(updatedUser);
      setResults(response);
      const taxes = await apiListTaxes(selectedRelease, selectedPraca);
      if (taxes.length > 0) {
        setTaxes(taxes[0]);
      }
    } catch (error) {
      addToast('Erro ao buscar insumos e serviços');
    } finally {
      setLoadingResults(false);
    }
  };

  const handleCartClick = (item, base, release) => {
    item.base = base;
    item.release = release;
    item.praca = selectedPraca;
    updateCart(item);
  }

  const handleDetailsClick = async (itemId) => {
    const selectedItem = results.find(result => result.id === itemId);
    setSelectedItem(selectedItem);
  }

  useEffect(() => {
    if (selectedItem && selectedItem.type) {
      showDetails(selectedItem.type, selectedItem.id);
    }
  }, [selectedItem]);

  const showDetails = async (itemType, itemId) => {
    setShowElements(false);
    setShowServices(false);

    if (itemType === 'I') {
      setShowElements(true);
    } else {
      try {
        const response = await apiListServiceItems(itemId, selectedRelease, selectedPraca);
        setServiceItems(response);
        setShowServices(true);
      } catch (error) {
        addToast('Erro ao buscar insumos e serviços');
      }
    }
  }



  const handleNext = () => {
    const currentIndex = results.findIndex(result => result.code === selectedItem.code);
    const nextIndex = (currentIndex + 1) % results.length;
    setSelectedItem(results[nextIndex]);
  };

  const handlePrev = () => {
    const currentIndex = results.findIndex(result => result.code === selectedItem.code);
    const prevIndex = (currentIndex - 1 + results.length) % results.length;
    setSelectedItem(results[prevIndex]);
  };

  const handleOnHideElements = () => {
    setShowElements(false);
    setSelectedItem({});
  };
  const handleOnHideServices = () => {
    setShowServices(false);
    setSelectedItem({});
  }


  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <PageTitle text='pesquisar' />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col md={2} className="">
            <Card className='mb-2'>
              <Card.Header className="bg-secondary text-white text-sm">CÓDIGO / DESCRIÇÃO</Card.Header>
              <Card.Body>
                <Form.Group className="">
                  <Form.Label className="text-muted text-sm">Filtrar itens que <strong>contenham</strong>:</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      size="sm"
                      value={newWithItem}
                      onChange={(e) => setNewWithItem(e.target.value)}
                      onKeyDown={handleWithKeyDown}
                    />
                    <Button variant="success" size="sm" onClick={handleWithAddItem}><i className="bi bi-plus-circle"></i></Button>
                  </InputGroup>
                </Form.Group>
                <ListGroup className='font-sm ' variant="flush" size="sm">
                  {has.map((item, index) => (
                    <ListGroup.Item
                      key={index}
                      onClick={() => handleHasRemoveItem(index)}
                      className="list-group-item-add-custom"
                    >
                      {item}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
              {has.length > 0 && (
                <Card.Footer className='p-1'>
                  <Button variant='link' size="sm" onClick={() => setHas([])}>limpar lista</Button>
                </Card.Footer>
              )}
            </Card>

            <Card className='mb-2'>
              <Card.Header className="bg-secondary text-white">CÓDIGO / DESCRIÇÃO</Card.Header>
              <Card.Body>
                <Form.Group className="">
                  <Form.Label className="text-muted">Filtrar itens que <strong>não contenham</strong>:</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      size="sm"
                      value={newWithoutItem}
                      onChange={(e) => setNewWithoutItem(e.target.value)}
                      onKeyDown={handleWithoutKeyDown}
                    />
                    <Button variant="danger" size="sm" onClick={handleWithoutAddItem}><i className="bi bi-dash-circle"></i></Button>
                  </InputGroup>
                </Form.Group>
                <ListGroup className='font-sm ' variant="flush" size="sm">
                  {hasNot.map((item, index) => (
                    <ListGroup.Item
                      key={index}
                      onClick={() => handleHasNotRemoveItem(index)}
                      className='list-group-item-del-custom'
                    >
                      {item}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
              {hasNot.length > 0 && (
                <Card.Footer className='p-1'>
                  <Button variant='link' size="sm" onClick={() => setHasNot([])}>limpar lista</Button>
                </Card.Footer>
              )}
            </Card>

            <Card className='mb-2'>
              <Card.Header className="bg-secondary text-white">PRAÇA DE COTAÇÃO</Card.Header>
              <Card.Body>
                <Form.Group className="">
                  <Form.Select
                    size="sm"
                    value={selectedPraca}
                    onChange={(e) => setSelectedPraca(e.target.value)}
                  >
                    <option key='' value=''>Selecione uma praça</option>
                    {braUfCities.map((uf) => (
                      <option key={uf.sigla} value={uf.sigla}>
                        {uf.sigla} / {uf.nome}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className='mb-2'>
              <Card.Header className="bg-secondary text-white">BASE DE DADOS</Card.Header>
              <Card.Body>
                <Form.Group className="">
                  <Form.Select
                    size="sm"
                    onChange={(e) => setSelectedBase(e.target.value)}
                  >
                    <option value=''>Selecione uma base</option>
                    {bases.map((base, index) => (
                      <option key={index} value={base.id}>{base.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className='mb-2'>
              <Card.Header className="bg-secondary text-white">VERSÃO DA BASE</Card.Header>
              <Card.Body>
                <Form.Group className="">
                  <Form.Select
                    size="sm"
                    onChange={(e) => setSelectedRelease(e.target.value)}
                  >
                    <option value=''>Selecione uma versão</option>
                    {releases.map((release, index) => (
                      <option key={index} value={release.id}>{release.year}/{release.month.toString().padStart(2, '0')}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className='mb-2 cost-group-container'>
              <Card.Header className="bg-secondary text-white text-sm cost-group-header">GRUPOS DE CUSTO</Card.Header>
              <Card.Body className='m-0 p-0 cost-group-body'>
                <div>
                  <div className='p-1'>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder='Filtrar grupos de custo'
                        disabled={costGroups.length === 0}
                        value={costGroupFilter}
                        onChange={(e) => setCostGroupFilter(e.target.value)}
                      />
                      <Button variant='primary' size='sm' disabled={costGroupFilter.length === 0} onClick={() => { setCostGroupFilter(''); setCostGroupFilter(''); }}>
                        <i className="bi bi-eraser"></i>
                      </Button>
                    </InputGroup>
                  </div>
                  <div className="cost-group-list">
                    <ListGroup variant="flush" size="sm">
                      {selectedRelease && loadingCostGroups && (
                        <div className='fw-light fs-6 small ps-1'>
                          Carregando grupos de custo...
                        </div>
                      )}
                      {filteredCostGroups.map((costGroup, index) => (
                        <ListGroup.Item
                          as="li"
                          className={`d-flex justify-content-between align-items-start p-1 me-2 ${activeCostGroup === costGroup.id ? 'active' : ''}`}
                          action
                          key={costGroup.id}
                          onClick={() => handleCostGroupClick(costGroup.id)}
                        >
                          <div className="fw-light fs-6 small ps-1">
                            {costGroup.description}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={10} className="bg-white">
            <Table hover size="sm" className="" id="searchTable">
              <thead>
                <tr>
                  <th>Base<br />Versão</th>
                  <th>Tipo</th>
                  <th>Código</th>
                  <th>Grupo de custos<br />Descrição</th>
                  <th>Un.</th>
                  <th>Preços</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {loadingResults && (
                  <tr>
                    <td colSpan="7" className="text-center">Carregando...</td>
                  </tr>
                )}
                {!loadingResults && results.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">Nenhum dado encontrado</td>
                  </tr>
                )}
                {results && Array.isArray(results) && results.map((result, index) => (
                  <tr key={index}>
                    <td valign='middle' className='text-nowrap'>{selectedBaseName} <br /> {selectedReleaseName}</td>
                    <td valign='middle'><TypeBadge type={result.type} /></td>
                    <td valign='middle'>{result.code}</td>
                    <td valign='middle'><span className='text-secondary'>{result.CostGroup.description}</span><br />{result.description}</td>
                    <td valign='middle'>{result.unity}</td>
                    <td className='text-nowrap'>
                      <FormattedPrice type='clsd' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].clsd : 0} />
                      <br />
                      <FormattedPrice type='clsn' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].clsn : 0} />
                      <br />
                      <FormattedPrice type='sls' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].sls : 0} />
                    </td>
                    <td valign='middle' className='text-nowrap '>
                      <Button variant='link' className='' onClick={() => handleCartClick(result, selectedBaseName, selectedReleaseName)}>
                        {Array.isArray(cart) && cart.some(item => item.id === result.id) ? (
                          <div className='text-danger'>
                            <i className="bi bi-dash-circle"></i>
                          </div>
                        ) : (
                          <div className='text-success'>
                            <i className="bi bi-plus-circle"></i>
                          </div>
                        )}
                      </Button>
                      <Button className='btn-sm' onClick={() => handleDetailsClick(result.id)}>
                        <i className="bi bi-box-arrow-up-right"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <ElementsPopup show={showElements} handleClose={handleOnHideElements} element={selectedItem} selectedBaseName={selectedBaseName} selectedReleaseName={selectedReleaseName} selectedPraca={selectedPraca} handleNext={handleNext} handlePrev={handlePrev} taxes={taxes} />
        <ServicesPopup show={showServices} handleClose={handleOnHideServices} service={selectedItem} selectedBaseName={selectedBaseName} selectedReleaseName={selectedReleaseName} selectedPraca={selectedPraca} handleNext={handleNext} handlePrev={handlePrev} items={serviceItems} />
      </Container>
    </>
  );
};

export default Search;